// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3f3rl","productName":"Table_productName__68QtJ"};